/* tools-calculators.js — /tools 공개 계산기 4종 클라이언트 배선 (2026-08-29)
 *
 * ★공식의 정본은 src/lib/tools-calc.ts 다★ — 이 파일은 같은 공식의 미러이고,
 * 동일성은 tests/unit/tools-calculators.test.ts 의 패리티 검증이 실행으로 고정한다.
 * ★인라인 이벤트 핸들러 0★ — 배선은 전부 addEventListener. 결과 표시는 createElement ·
 * textContent 만 쓴다 — 입력값이 마크업으로 해석될 여지를 만들지 않는다.
 */
(function () {
  'use strict';

  function isPositiveFinite(n) { return typeof n === 'number' && isFinite(n) && n > 0; }
  function round2(n) { return Math.round(n * 100) / 100; }

  function parseIsoDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!m) return null;
    var y = Number(m[1]); var mo = Number(m[2]); var d = Number(m[3]);
    var ts = Date.UTC(y, mo - 1, d);
    var check = new Date(ts);
    if (check.getUTCFullYear() !== y || check.getUTCMonth() !== mo - 1 || check.getUTCDate() !== d) return null;
    return ts;
  }

  /* 계속근로 1년 — ★달력으로 센다★(민법 제155조·제157조 단서·제160조). 정본: tools-calc.ts hasCompletedOneYear.
     퇴직일(마지막 근무일 다음 날) >= 입사일의 1년 뒤 같은 날. 2월 29일 입사는 날짜 넘김으로 3월 1일이 기준이 된다.
     근속 365일 이상으로 대신하면 2월 29일이 낀 해에 하루 이르게 대상이 된다. */
  function completedOneYear(hireIso, leaveIso) {
    var hire = parseIsoDate(hireIso); var leave = parseIsoDate(leaveIso);
    if (hire === null || leave === null || leave < hire) return null;
    var h = new Date(hire);
    return leave >= Date.UTC(h.getUTCFullYear() + 1, h.getUTCMonth(), h.getUTCDate());
  }

  var calc = {
    minimumHourlyWage2026: 10320,

    weeklyHolidayPay: function (weeklyHours, hourlyWage) {
      if (!isPositiveFinite(weeklyHours) || !isPositiveFinite(hourlyWage) || weeklyHours < 15) {
        return { eligible: false, holidayHours: 0, amount: 0 };
      }
      var rawHours = (Math.min(weeklyHours, 40) / 40) * 8;
      return { eligible: true, holidayHours: round2(rawHours), amount: Math.round(rawHours * hourlyWage) };
    },

    annualLeave: function (fullYears, fullMonths) {
      var years = isFinite(fullYears) ? Math.floor(fullYears) : 0;
      var months = isFinite(fullMonths) ? Math.floor(fullMonths) : 0;
      if (years < 1) {
        return { days: Math.min(Math.max(months, 0), 11), basis: 'under-one-year' };
      }
      return { days: Math.min(15 + Math.floor((years - 1) / 2), 25), basis: 'annual' };
    },

    daysBetween: function (fromIso, toIso) {
      var a = parseIsoDate(fromIso); var b = parseIsoDate(toIso);
      if (a === null || b === null || b < a) return null;
      return Math.round((b - a) / 86400000);
    },

    addMonthsIso: function (iso, delta) {
      var ts = parseIsoDate(iso);
      if (ts === null || !isFinite(delta)) return null;
      var d = new Date(ts);
      var y = d.getUTCFullYear(); var mo = d.getUTCMonth() + delta; var day = d.getUTCDate();
      var targetYear = y + Math.floor(mo / 12);
      var targetMonth = ((mo % 12) + 12) % 12;
      var lastDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
      var clamped = Math.min(day, lastDay);
      var out = new Date(Date.UTC(targetYear, targetMonth, clamped));
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      return out.getUTCFullYear() + '-' + pad(out.getUTCMonth() + 1) + '-' + pad(out.getUTCDate());
    },

    serviceSpan: function (hireIso, asOfIso) {
      var hire = parseIsoDate(hireIso); var asOf = parseIsoDate(asOfIso);
      if (hire === null || asOf === null || asOf < hire) return null;
      var h = new Date(hire); var a = new Date(asOf);
      var months = (a.getUTCFullYear() - h.getUTCFullYear()) * 12 + (a.getUTCMonth() - h.getUTCMonth());
      if (a.getUTCDate() < h.getUTCDate()) months -= 1;
      if (months < 0) months = 0;
      return {
        fullYears: Math.floor(months / 12),
        remainderMonths: months % 12,
        totalMonths: months,
        totalDays: Math.round((asOf - hire) / 86400000)
      };
    },

    hasCompletedOneYear: completedOneYear,

    severancePay: function (serviceDays, wageTotalLast3Months, daysInLast3Months, weeklyHours, hireIso, leaveIso) {
      var valid = isPositiveFinite(serviceDays) && isPositiveFinite(wageTotalLast3Months)
        && isPositiveFinite(daysInLast3Months) && isPositiveFinite(weeklyHours);
      var oneYear = (hireIso !== undefined && leaveIso !== undefined)
        ? completedOneYear(hireIso, leaveIso) === true
        : serviceDays >= 365;
      if (!valid || !oneYear || weeklyHours < 15) {
        return { eligible: false, averageDailyWage: 0, amount: 0 };
      }
      var avgDaily = wageTotalLast3Months / daysInLast3Months;
      return {
        eligible: true,
        averageDailyWage: Math.round(avgDaily),
        amount: Math.round(avgDaily * 30 * (serviceDays / 365))
      };
    },

    parseClockToMinutes: function (value) {
      var m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec((value || '').trim());
      if (!m) return null;
      return Number(m[1]) * 60 + Number(m[2]);
    },

    nightAllowance: function (startMinutes, endMinutes, hourlyWage) {
      var validClock = isFinite(startMinutes) && isFinite(endMinutes)
        && startMinutes >= 0 && startMinutes < 1440 && endMinutes >= 0 && endMinutes < 1440;
      if (!validClock || !isPositiveFinite(hourlyWage)) {
        return { nightHours: 0, allowance: 0 };
      }
      var windows = [[0, 360], [1320, 1800], [2760, 3240]];
      var start = startMinutes;
      var end = endMinutes <= startMinutes ? endMinutes + 1440 : endMinutes;
      var nightMinutes = 0;
      for (var i = 0; i < windows.length; i++) {
        var overlap = Math.min(end, windows[i][1]) - Math.max(start, windows[i][0]);
        if (overlap > 0) nightMinutes += overlap;
      }
      var nightHours = nightMinutes / 60;
      return { nightHours: round2(nightHours), allowance: Math.round(nightHours * hourlyWage * 0.5) };
    },

    /* ── 2026-09-09 추가 3종 (사대보험 · 연차수당 · 근무일수) ──────────────
       ★요율의 정본은 마이그 0307 statutory_rates(2026-01-01 시행)★ 이고 TS 쪽은
       payroll-calc 의 RATE_* 를 import 한다. 여기는 그 미러라 값을 직접 적는다 —
       ★갈라지면 패리티 테스트가 red★ (tests/contracts/tools-calculators-2026-09.test.ts). */
    insuranceWorkerRates: { pension: 0.0475, health: 0.03595, longTermCare: 0.009448 / 0.0719, employment: 0.009 },

    fourMajorInsurance: function (monthlyWage, nonTaxable) {
      var minus = (isFinite(nonTaxable) && nonTaxable > 0) ? nonTaxable : 0;
      var wage = monthlyWage - minus;
      if (!isPositiveFinite(monthlyWage) || !isPositiveFinite(wage)) {
        return { valid: false, baseWage: 0, pension: 0, health: 0, longTermCare: 0, employment: 0, total: 0 };
      }
      var r = calc.insuranceWorkerRates;
      /* 끝수 — 정본 payroll-calc.computeInsuranceDeductions 미러: 건강·장기요양 10원 미만 절사 */
      var trunc10 = function (x) { return Math.floor(Math.round(x * 1000) / 1000 / 10) * 10; };
      var pension = Math.round(wage * r.pension);
      var health = trunc10(wage * r.health);
      var longTermCare = trunc10(health * r.longTermCare);
      var employment = Math.round(wage * r.employment);
      return {
        valid: true, baseWage: wage, pension: pension, health: health, longTermCare: longTermCare,
        employment: employment, total: pension + health + longTermCare + employment
      };
    },

    /* minimumHourlyWage — 비교할 최저시급. 비우면(undefined·null) 2026 값. 정본: calcAnnualLeaveAllowance 의 input.minimumHourlyWage. */
    annualLeaveAllowance: function (unusedDays, monthlyOrdinaryWage, monthlyStandardHours, dailyStandardHours, minimumHourlyWage) {
      var daysOk = isFinite(unusedDays) && unusedDays >= 0;
      var ok = daysOk && isPositiveFinite(monthlyOrdinaryWage)
        && isPositiveFinite(monthlyStandardHours) && isPositiveFinite(dailyStandardHours);
      if (!ok) {
        return { valid: false, hourlyOrdinaryWage: 0, dailyOrdinaryWage: 0, amount: 0, belowMinimumWage: false };
      }
      var rawHourly = monthlyOrdinaryWage / monthlyStandardHours;
      var rawDaily = rawHourly * dailyStandardHours;
      return {
        valid: true,
        hourlyOrdinaryWage: Math.round(rawHourly),
        dailyOrdinaryWage: Math.round(rawDaily),
        amount: Math.round(rawDaily * unusedDays),
        belowMinimumWage: rawHourly < ((minimumHourlyWage === undefined || minimumHourlyWage === null)
          ? calc.minimumHourlyWage2026 : minimumHourlyWage)
      };
    },

    workingDaysMaxSpan: 3660,

    /** holidays 는 'YYYY-MM-DD' 배열(TS 쪽은 Set — 패리티 테스트가 변환해 맞춘다). */
    workingDays: function (startIso, endIso, weeklyWorkDays, excludeHolidays, holidays) {
      function empty(reason) {
        return {
          valid: false, reason: reason, totalDays: 0, workingDays: 0, restDays: 0,
          holidaysExcluded: 0, holidaysApplied: false, uncoveredYears: []
        };
      }
      var start = parseIsoDate(startIso);
      var end = parseIsoDate(endIso);
      if (start === null || end === null || end < start) return empty('invalid-date');
      var week = isFinite(weeklyWorkDays) ? Math.floor(weeklyWorkDays) : 0;
      if (week < 1 || week > 7) return empty('invalid-week-days');
      var totalDays = Math.round((end - start) / 86400000) + 1;
      if (totalDays > calc.workingDaysMaxSpan) return empty('range-too-long');

      var lookup = {};
      var covered = {};
      var size = 0;
      for (var k = 0; holidays && k < holidays.length; k++) {
        if (!lookup[holidays[k]]) { lookup[holidays[k]] = true; size++; }
        covered[Number(String(holidays[k]).slice(0, 4))] = true;
      }
      var holidaysApplied = !!excludeHolidays && size > 0;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var uncovered = {};
      var workingDays = 0; var restDays = 0; var holidaysExcluded = 0;
      for (var i = 0; i < totalDays; i++) {
        var day = new Date(start + i * 86400000);
        var mondayIndex = (day.getUTCDay() + 6) % 7;
        if (mondayIndex >= week) { restDays++; continue; }
        if (holidaysApplied) {
          var year = day.getUTCFullYear();
          if (!covered[year]) { uncovered[year] = true; }
          var iso = year + '-' + pad(day.getUTCMonth() + 1) + '-' + pad(day.getUTCDate());
          if (lookup[iso]) { holidaysExcluded++; continue; }
        }
        workingDays++;
      }
      var uncoveredYears = Object.keys(uncovered).map(Number).sort(function (a, b) { return a - b; });
      return {
        valid: true, reason: 'ok', totalDays: totalDays, workingDays: workingDays,
        restDays: restDays, holidaysExcluded: holidaysExcluded, holidaysApplied: holidaysApplied,
        uncoveredYears: uncoveredYears
      };
    },

    /* 주52시간 — 정본: tools-calc.ts calcWeeklyHours52. ★법정 숫자는 적지 않는다★ — 서버가 정본(WORKING_HOURS ·
       UNDER_FIVE_APPLICABILITY)에서 읽어 입력으로 넘긴다(weeklyHours · dailyStandardHours · weeklyLimitHours · underFiveApplies).
       dailyHours 는 월~일 7칸이고 빈칸은 NaN(0 으로 본다). regime 이 'standard' 가 아니면 계산하지 않는다. */
    weeklyHours52: function (input) {
      var weekly = input.weeklyHours;
      var daily = input.dailyStandardHours;
      var limit = input.weeklyLimitHours - weekly;
      var base = {
        status: 'invalid', totalHours: 0, weeklyStandardHours: weekly, overtimeLimitHours: limit,
        limitOvertimeHours: 0, remainingHours: 0, excessHours: 0, premiumOvertimeHours: 0, withinLimit: false
      };
      function withStatus(status, totalHours) {
        var out = {};
        for (var key in base) out[key] = base[key];
        out.status = status; out.totalHours = totalHours;
        return out;
      }
      var days = input.dailyHours;
      if (!Array.isArray(days) || days.length !== 7) return base;
      var filled = days.filter(function (h) { return !Number.isNaN(h); });
      if (!filled.length) return base;
      if (filled.some(function (h) { return !Number.isFinite(h) || h < 0 || h > 24; })) return base;
      var hours = days.map(function (h) { return Number.isNaN(h) ? 0 : h; });
      var totalHours = round2(hours.reduce(function (a, h) { return a + h; }, 0));
      if (!input.fivePlus && !input.underFiveApplies) return withStatus('not-applicable', totalHours);
      if (input.regime !== 'standard') return withStatus('not-computed', totalHours);
      var limitOvertimeHours = round2(Math.max(0, totalHours - weekly));
      var dailyOver = hours.reduce(function (a, h) { return a + Math.max(0, h - daily); }, 0);
      var withinDaily = hours.reduce(function (a, h) { return a + Math.min(h, daily); }, 0);
      var out = withStatus('ok', totalHours);
      out.limitOvertimeHours = limitOvertimeHours;
      out.remainingHours = round2(Math.max(0, limit - limitOvertimeHours));
      out.excessHours = round2(Math.max(0, limitOvertimeHours - limit));
      out.premiumOvertimeHours = round2(dailyOver + Math.max(0, withinDaily - weekly));
      out.withinLimit = limitOvertimeHours <= limit;
      return out;
    }
  };

  /* 패리티 테스트(jest)가 이 전역으로 순수 계산 함수를 읽는다. */
  if (typeof globalThis !== 'undefined') globalThis.INSACHECK_TOOLS_CALC = calc;

  /* 이하 DOM 배선 — 브라우저에서만. */
  if (typeof document === 'undefined' || !document.addEventListener) return;

  function fmtWon(n) {
    try { return n.toLocaleString('ko-KR') + '원'; } catch (e) { return String(n) + '원'; }
  }
  function fmtHours(n) {
    return (Math.round(n * 100) / 100) + '시간';
  }
  function numValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el || el.value === '') return NaN;
    return Number(el.value);
  }
  function strValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value : '';
  }
  function todayIso() {
    var d = /*t:DEVICE_NOW*/new Date()/*t*/;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  /* 결과 박스: 굵은 헤드라인 1줄 + 보조 설명 줄들. 전부 textContent 로 쓴다. */
  function setResult(form, state, headline, lines) {
    var box = form.querySelector('[data-result]');
    if (!box) return;
    while (box.firstChild) box.removeChild(box.firstChild);
    box.setAttribute('data-state', state);
    var strong = document.createElement('strong');
    strong.textContent = headline;
    box.appendChild(strong);
    for (var i = 0; i < (lines || []).length; i++) {
      box.appendChild(document.createElement('br'));
      box.appendChild(document.createTextNode(lines[i]));
    }
  }

  var handlers = {
    'weekly-holiday': function (form) {
      var weeklyHours = numValue(form, 'weeklyHours');
      var hourlyWage = numValue(form, 'hourlyWage');
      if (!isFinite(weeklyHours) || !isFinite(hourlyWage) || weeklyHours <= 0 || hourlyWage <= 0) {
        setResult(form, 'error', '입력값을 확인해 주세요.', ['1주 소정근로시간과 시급을 숫자로 입력해 주세요.']);
        return;
      }
      var r = calc.weeklyHolidayPay(weeklyHours, hourlyWage);
      if (!r.eligible) {
        setResult(form, 'ok', '주휴수당 대상이 아닙니다 (0원)', [
          '1주 소정근로시간이 15시간 미만인 초단시간 근로자는 주휴수당 적용 대상에서 제외됩니다 (근로기준법 제18조 제3항).'
        ]);
        return;
      }
      setResult(form, 'ok', '1주 주휴수당 약 ' + fmtWon(r.amount), [
        '주휴시간 ' + fmtHours(r.holidayHours) + ' × 시급 ' + fmtWon(hourlyWage),
        '그 주 소정근로일을 개근했을 때 기준이며, 결근한 주는 발생하지 않을 수 있습니다.'
      ]);
    },

    'annual-leave': function (form) {
      var hire = strValue(form, 'hireDate');
      var asOf = strValue(form, 'asOfDate') || todayIso();
      var span = calc.serviceSpan(hire, asOf);
      if (!span) {
        setResult(form, 'error', '날짜를 확인해 주세요.', ['입사일이 기준일보다 빠른 올바른 날짜여야 합니다.']);
        return;
      }
      var r = calc.annualLeave(span.fullYears, span.totalMonths);
      var spanText = '근속 만 ' + span.fullYears + '년 ' + span.remainderMonths + '개월';
      if (r.basis === 'under-one-year') {
        setResult(form, 'ok', '연차 최대 ' + r.days + '일 (' + spanText + ')', [
          '근속 1년 미만은 1개월 개근 시 1일씩, 최대 11일까지 발생합니다 (근로기준법 제60조 제2항).',
          '결근 등으로 개근하지 못한 달은 발생하지 않으므로 실제 일수는 이보다 적을 수 있습니다.'
        ]);
        return;
      }
      setResult(form, 'ok', '연차 ' + r.days + '일 (' + spanText + ')', [
        '기본 15일 + 3년차부터 2년마다 1일 가산, 상한 25일 (근로기준법 제60조).',
        '1년간 80% 이상 출근을 전제로 한 값이며, 상시 5인 미만 사업장에는 연차 조항이 적용되지 않습니다.'
      ]);
    },

    'severance': function (form) {
      var hire = strValue(form, 'hireDate');
      var leave = strValue(form, 'leaveDate');
      var wageTotal = numValue(form, 'wageTotal');
      var weeklyHours = numValue(form, 'weeklyHours');
      var serviceDays = calc.daysBetween(hire, leave);
      if (serviceDays === null) {
        setResult(form, 'error', '날짜를 확인해 주세요.', ['입사일이 퇴직일보다 빠른 올바른 날짜여야 합니다.']);
        return;
      }
      if (!isFinite(wageTotal) || wageTotal <= 0 || !isFinite(weeklyHours) || weeklyHours <= 0) {
        setResult(form, 'error', '입력값을 확인해 주세요.', ['최근 3개월 임금총액과 1주 소정근로시간을 숫자로 입력해 주세요.']);
        return;
      }
      var periodStart = calc.addMonthsIso(leave, -3);
      var days3m = periodStart ? calc.daysBetween(periodStart, leave) : null;
      if (!days3m) {
        setResult(form, 'error', '날짜를 확인해 주세요.', ['퇴직일에서 3개월 전 기간을 계산할 수 없습니다.']);
        return;
      }
      var r = calc.severancePay(serviceDays, wageTotal, days3m, weeklyHours, hire, leave);
      if (!r.eligible) {
        var oneYear = calc.hasCompletedOneYear(hire, leave) === true;
        var why = !oneYear
          ? '계속근로기간이 1년 미만이면 퇴직금 지급 대상이 아닙니다 (근로자퇴직급여 보장법 제4조).'
          : '1주 소정근로시간이 15시간 미만인 초단시간 근로자는 퇴직금 적용 대상에서 제외됩니다.';
        var lines = [why, '근속일수 ' + serviceDays + '일 기준.'];
        if (!oneYear && serviceDays >= 365) {
          lines.push('이 기간에는 2월 29일이 있어 달력상 1년이 366일입니다. 1년은 날짜로 셉니다 (민법 제160조).');
        }
        setResult(form, 'ok', '퇴직금 지급 대상이 아닙니다 (0원)', lines);
        return;
      }
      setResult(form, 'ok', '퇴직금 약 ' + fmtWon(r.amount), [
        '1일 평균임금 약 ' + fmtWon(r.averageDailyWage) + ' (3개월 임금총액 ÷ ' + days3m + '일) × 30일 × 근속 ' + serviceDays + '일 ÷ 365',
        '상여금·미사용 연차수당 산입, 통상임금 비교는 반영하지 않은 간이 추정입니다.'
      ]);
    },

    'night-allowance': function (form) {
      var start = calc.parseClockToMinutes(strValue(form, 'startTime'));
      var end = calc.parseClockToMinutes(strValue(form, 'endTime'));
      var hourlyWage = numValue(form, 'hourlyWage');
      if (start === null || end === null || !isFinite(hourlyWage) || hourlyWage <= 0) {
        setResult(form, 'error', '입력값을 확인해 주세요.', ['출근·퇴근 시각과 시급을 입력해 주세요.']);
        return;
      }
      var r = calc.nightAllowance(start, end, hourlyWage);
      if (r.nightHours <= 0) {
        setResult(form, 'ok', '야간근로 가산 대상 시간이 없습니다 (0원)', [
          '입력한 근무시간이 야간근로 구간(22:00~다음날 06:00)과 겹치지 않습니다.'
        ]);
        return;
      }
      setResult(form, 'ok', '야간수당(가산분) 약 ' + fmtWon(r.allowance), [
        '야간근로 ' + fmtHours(r.nightHours) + ' × 시급 ' + fmtWon(hourlyWage) + ' × 50%',
        '기본 시급분과 별도로 더해지는 가산분이며, 상시 5인 이상 사업장에 적용됩니다.',
        '휴게시간이 야간에 끼어 있으면 그 시간은 빼고 보아야 합니다.'
      ]);
    },

    /* ── 2026-09-09 추가 3종 ────────────────────────────────────────────── */

    'four-insurance': function (form) {
      var wage = numValue(form, 'monthlyWage');
      var nonTaxableRaw = numValue(form, 'nonTaxable');
      var nonTaxable = isFinite(nonTaxableRaw) ? nonTaxableRaw : 0;
      var r = calc.fourMajorInsurance(wage, nonTaxable);
      if (!r.valid) {
        setResult(form, 'error', '입력값을 확인해 주세요.', [
          '세전 월 급여를 숫자로 입력하고, 비과세 수당은 월 급여보다 작게 넣어 주세요.'
        ]);
        return;
      }
      setResult(form, 'ok', '근로자 부담 합계 약 ' + fmtWon(r.total), [
        '국민연금 ' + fmtWon(r.pension) + ' · 건강보험 ' + fmtWon(r.health)
          + ' · 장기요양 ' + fmtWon(r.longTermCare) + ' · 고용보험 ' + fmtWon(r.employment),
        '보수월액 ' + fmtWon(r.baseWage) + ' 기준 · 2026-01-01 시행 근로자 부담 요율입니다.',
        '사업주 부담분과 산재보험, 소득세는 계산에 넣지 않았습니다. 국민연금은 기준소득월액 상·하한이 있어 고소득·저소득 구간에서는 실제 공제액이 달라집니다.'
      ]);
    },

    'annual-leave-allowance': function (form) {
      var days = numValue(form, 'unusedDays');
      var monthly = numValue(form, 'monthlyOrdinaryWage');
      var monthlyHours = numValue(form, 'monthlyStandardHours');
      var dailyHours = numValue(form, 'dailyStandardHours');
      /* 최저시급 — 서버가 그날 기준 값을 data-min-wage · data-min-wage-year 로 구워 준다. 없으면 2026 값. */
      var minWageRaw = Number(form.dataset.minWage);
      var minWage = (form.dataset.minWage && isPositiveFinite(minWageRaw)) ? minWageRaw : calc.minimumHourlyWage2026;
      var minWageYear = form.dataset.minWageYear || '2026';
      var r = calc.annualLeaveAllowance(days, monthly, monthlyHours, dailyHours, minWage);
      if (!r.valid) {
        setResult(form, 'error', '입력값을 확인해 주세요.', [
          '미사용 연차 일수, 월 통상임금, 월 소정근로시간, 1일 소정근로시간을 숫자로 입력해 주세요.'
        ]);
        return;
      }
      var lines = [
        '1일 통상임금 약 ' + fmtWon(r.dailyOrdinaryWage)
          + ' (통상시급 ' + fmtWon(r.hourlyOrdinaryWage) + ' × ' + dailyHours + '시간) × 미사용 ' + days + '일',
        '입력하신 월 통상임금을 그대로 나눈 값입니다. 통상임금에 어떤 수당이 들어가는지는 회사 임금 구성에 따라 달라집니다.'
      ];
      if (r.belowMinimumWage) {
        lines.push('통상시급이 ' + minWageYear + '년 최저시급 ' + fmtWon(minWage)
          + '보다 낮습니다 — 월 통상임금과 월 소정근로시간을 다시 확인해 주세요.');
      }
      setResult(form, 'ok', '연차 미사용 수당 약 ' + fmtWon(r.amount), lines);
    },

    'hours52': function (form) {
      var dailyHours = [];
      for (var d = 0; d < 7; d++) dailyHours.push(numValue(form, 'h' + d));
      var weekHours = Number(form.dataset.weekHours);
      var dayHours = Number(form.dataset.dayHours);
      var weekLimit = Number(form.dataset.weekLimit);
      var r = calc.weeklyHours52({
        dailyHours: dailyHours,
        fivePlus: strValue(form, 'five_plus') === '1',
        regime: strValue(form, 'regime'),
        weeklyHours: weekHours,
        dailyStandardHours: dayHours,
        weeklyLimitHours: weekLimit,
        underFiveApplies: form.dataset.underFiveApplies === 'true'
      });
      /* 안내 글은 서버가 굽는다 — 먼저 전부 숨기고, 결과에 맞는 하나만 연다. */
      var notes = form.querySelectorAll('[data-regime-note]');
      for (var n = 0; n < notes.length; n++) notes[n].hidden = true;
      function showNote(key) {
        for (var i = 0; i < notes.length; i++) {
          if (notes[i].getAttribute('data-regime-note') === key) notes[i].hidden = false;
        }
      }
      if (r.status === 'invalid') {
        setResult(form, 'error', '하루 근무시간을 0~24 사이로 한 칸 이상 입력해 주세요');
        return;
      }
      var total = '1주 합계 ' + fmtHours(r.totalHours);
      if (r.status === 'not-applicable') {
        showNote('under-five');
        setResult(form, 'ok', '상시 4명 이하 사업장 — 1주 연장 한도가 적용되지 않습니다', [total]);
        return;
      }
      if (r.status === 'not-computed') {
        showNote(strValue(form, 'regime'));
        setResult(form, 'ok', '이 근로시간 제도는 계산하지 않습니다', [total + ' — 아래 설명과 안내 글을 확인해 주세요']);
        return;
      }
      var head = r.withinLimit
        ? '1주 연장 ' + fmtHours(r.limitOvertimeHours) + ' — 한도 안, 남은 ' + fmtHours(r.remainingHours)
        : '1주 연장 ' + fmtHours(r.limitOvertimeHours) + ' — 한도를 ' + fmtHours(r.excessHours) + ' 넘었습니다';
      var lines = [
        total,
        '한도 판정용 연장 = 합계 ' + fmtHours(r.totalHours) + ' − 1주 법정 ' + fmtHours(r.weeklyStandardHours)
          + ' = ' + fmtHours(r.limitOvertimeHours) + ' (1주 연장 한도 ' + fmtHours(r.overtimeLimitHours) + ')',
        '(참고) 가산수당 대상 연장 ' + fmtHours(r.premiumOvertimeHours) + ' — 1일 ' + fmtHours(dayHours)
          + ' 초과분과 1주 ' + fmtHours(r.weeklyStandardHours) + ' 초과분을 겹치지 않게 센 값'
      ];
      if (r.premiumOvertimeHours !== r.limitOvertimeHours) {
        lines.push('두 값이 다른 이유: 연장 한도는 1주 ' + fmtHours(r.weeklyStandardHours) + '을 넘은 시간만 세고, 가산수당은 하루 '
          + fmtHours(dayHours) + '을 넘은 시간도 셉니다 (대법원 2023. 12. 7. 선고 2020도15393)');
      }
      setResult(form, 'ok', head, lines);
    },

    'working-days': function (form) {
      var start = strValue(form, 'startDate');
      var end = strValue(form, 'endDate');
      var week = numValue(form, 'weeklyWorkDays');
      var box = form.querySelector('[name="excludeHolidays"]');
      var exclude = !!(box && box.checked);
      var attr = form.getAttribute('data-holidays') || '';
      var list = attr ? attr.split(' ') : [];
      var r = calc.workingDays(start, end, week, exclude, list);
      if (!r.valid) {
        var why = r.reason === 'invalid-week-days'
          ? '주 근무일수는 1~7 사이로 입력해 주세요.'
          : (r.reason === 'range-too-long'
            ? '기간이 너무 깁니다. 10년 이내로 나눠서 계산해 주세요.'
            : '시작일이 종료일보다 빠른 올바른 날짜여야 합니다.');
        setResult(form, 'error', '입력값을 확인해 주세요.', [why]);
        return;
      }
      var lines = [
        '달력 ' + r.totalDays + '일 중 휴무일 ' + r.restDays + '일'
          + (r.holidaysApplied ? ' · 근무요일과 겹친 공휴일 ' + r.holidaysExcluded + '일 제외' : ''),
        '주 ' + Math.floor(week) + '일 근무를 월요일부터 세었습니다 (주 5일 = 월~금, 주 6일 = 월~토).'
      ];
      if (exclude && !r.holidaysApplied) {
        lines.push('공휴일 표를 불러오지 못해 공휴일을 빼지 않았습니다.');
      } else if (r.uncoveredYears.length) {
        lines.push(r.uncoveredYears.join('·') + '년은 공휴일 표에 없어 그 해의 공휴일은 빼지 않았습니다.');
      }
      setResult(form, 'ok', '근무일 ' + r.workingDays + '일', lines);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('form[data-calc]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        var kind = form.getAttribute('data-calc');
        var handler = handlers[kind];
        if (!handler) return;
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          handler(form);
        });
      })(forms[i]);
    }

    /* 연차·퇴직금 계산기의 기준일 기본값 = 오늘 (SSR 은 날짜를 굽지 않는다 — 캐시 안전). */
    var asOfInputs = document.querySelectorAll('form[data-calc] input[name="asOfDate"]');
    for (var j = 0; j < asOfInputs.length; j++) {
      if (!asOfInputs[j].value) asOfInputs[j].value = todayIso();
    }
  });
})();
